// AuthContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const baseUrl = 'http://dawsonhighwaycafeandindiancuisine.com/music-dashboard/public';
    useEffect(() => {
        const userData = localStorage.getItem('userData');
        if (userData) setUser(JSON.parse(userData));
    }, []);

    const login = async (email, password) => {
        try {
            if (email === 'admin@example.com' && password === 'admin123') {
                const userData = { email, role: 'admin', isLoggedIn: true };
                localStorage.setItem('userData', JSON.stringify(userData));
                setUser(userData);
                return true;
            }
            const response = await axios.post('http://dawsonhighwaycafeandindiancuisine.com/api/login_user.php', {
                'email': email,
                'password': password,
            });
            if (response.data.status === 200) {
                const userData = { email, role: 'user', isLoggedIn: true, 'user_id':response.data.user_id };
                localStorage.setItem('userData', JSON.stringify(userData));
                setUser(userData);
                return true;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
        return false;
    };

    const logout = () => {
        localStorage.removeItem('userData');
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);